<template lang="html">
  <div class="page-result">
    <h4>收藏{{$store.state.themename}}：</h4>
    <div class="themenamelist">
      <el-row class="themename-box" v-if="themenameList.length>0">
        <el-col :span="6" v-for="(item, index) in themenameList" :key="item.course.id" :class="['themename', {'themename-top':index<4}, {'themename-left':index%4===0}, {'themename-right':index%4===3}]">
          <el-card :body-style="{ padding: '0px' }" class="themename-card">
            <!-- <router-link :to="{ name: 'video', params: {type:item.course.liveFlag===0?'vod':'live',id:item.course.id} }" target="_blank" class="themename-image">
              <img :src="item.course.cover" :onerror="$store.state.errorImage" width="100%" height="56.25%">
            </router-link> -->
            <div class="themename-card-cover" :style="'background:url('+(item.course.cover)+') center center / cover no-repeat;'" @click="ViewVideo(item)" v-if="item.course.cover!=undefined&&item.course.cover!=''"></div>
            <div class="themename-card-cover" :style="'background:url('+($store.state.defaultImage)+') center center / cover no-repeat;'" @click="ViewVideo(item)" v-else></div>
            <div class="themename-card-bottom">
              <div class="themename-card-bottom1 over">
                <router-link :to="{ name: 'video', params: {type:item.course.liveFlag===0?'vod':'live',id:item.course.id} }" target="_blank">
                  {{item.course.name}}
                </router-link>
              </div>
              <div class="themename-card-bottom2 clearfix">
                <span class="lecturename">{{item.course.lecturerName}}</span>
                <el-button type="text" class="button" @click="CancelCollect(item)">取消收藏</el-button>
              </div>
            </div>
          </el-card>
        </el-col>
      </el-row>
      <div class="empty-data" style="height:300px;line-height:300px;" v-if="themenameList.length===0">
        暂无内容
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/api/api.js';

export default {
  inject: ['reload'],
  data() {
    return {
      pgPageNum: 1,
      pgPageLimit: 999999,
      themenameList: []
    }
  },
  computed: {
    isAuthed() {
      return window.localStorage.USERID !== undefined && window.localStorage.USERID !== "";
    }
  },
  async created() {
    if (this.isAuthed) {
      let params = {
        pgPageNum: this.pgPageNum,
        pgLimit: this.pgPageLimit
      };
      this.themenameList = await this.GetCollectThemeName(params);
    } else {
      this.openError("请登录后再查看收藏课程！");
    }
  },
  methods: {
    openSuccess(text) {
      this.$message({
        showClose: true,
        message: text,
        type: 'success'
      });
    },
    openError(text) {
      this.$message({
        showClose: true,
        message: text,
        type: 'error'
      });
    },
    async GetCollectThemeName(param) {
      let response = await Api.GetCollectThemeName(param);
      if (response.success) {
        return response.resList || [];
      } else {
        this.$message({
          showClose: true,
          message: this.$store.state.message.errorMsg,
          type: 'error'
        });
        return [];
      }
    },
    async CancelCollect(themename) {
      let response = await Api.CancelCollectThemeName(themename.id);
      if (response.resCode === 0) {
        let params = {
          pgPageNum: this.pgPageNum,
          pgLimit: this.pgPageLimit
        };
        this.themenameList = await this.GetCollectThemeName(params);
      } else {
        this.$message({
          showClose: true,
          message: this.$store.state.message.errorMsg,
          type: 'error'
        });
        return [];
      }
    },
    ViewVideo(item) {
      let route = this.$router.resolve({
        name: "video",
        params: {
          type: item.course.liveFlag === 0 ? 'vod' : 'live',
          id: item.course.id
        }
      });
      window.open(route.href, '_blank');
    }
  }
}
</script>

<style lang="css">
  .el-carousel__item h3 {
    color: #475669;
    font-size: 14px;
    opacity: 0.75;
    line-height: 300px;
    margin: 0;
  }

  .el-carousel__arrow {
    width: 60px !important;
    height: 60px !important;
  }

  .el-carousel__arrow .el-icon-arrow-left,
  .el-carousel__arrow .el-icon-arrow-right {
    font-size: 30px;
  }

  .button {
    padding: 0;
    float: right;
  }

  .image {
    width: 100%;
    display: block;
  }

  .clearfix:before,
  .clearfix:after {
      display: table;
      content: "";
  }

  .clearfix:after {
      clear: both
  }
</style>
